import React from "react";
import {Modal} from "@mui/material";
import MainCard from "../../../components/MainCard";
import SimpleBar from 'components/third-party/SimpleBar';
import {ColumnFiltersState} from "@tanstack/react-table";


interface Props<T> {
    open: boolean;
    setOpen: (state: boolean) => void,
    element: T | null
    FormComponent: React.FC<{
        closeModal: () => void;
        element: T | null;
        onSuccess?: () => void;
        pageableData?: {
            page: number;
            rowsPerPage: number;
            filters: ColumnFiltersState | null;
        };
    }>;
    onSuccess?: () => void;
    pageableData?: {
        page: number;
        rowsPerPage: number;
        filters: ColumnFiltersState | null;
    };
}

export default function ElementModalGeneric<T>({
                                                   open,
                                                   setOpen,
                                                   element,
                                                   FormComponent,
                                                   onSuccess,
                                                   pageableData
                                               }: Props<any>) {

    const closeModal = () => setOpen(false);

    return (
        <>
            {open && (
                <Modal
                    open={open}
                    onClose={closeModal}
                    aria-labelledby="modal-customer-add-label"
                    aria-describedby="modal-customer-add-description"
                    sx={{'& .MuiPaper-root:focus': {outline: 'none'}}}
                >
                    <MainCard
                        sx={{
                            width: `calc(100% - 48px)`,
                            minWidth: 340,
                            maxWidth: 880,
                            height: 'auto',
                            maxHeight: 'calc(100vh - 48px)'
                        }}
                        modal
                        content={false}
                    >
                        <SimpleBar sx={{
                            maxHeight: `calc(100vh - 48px)`,
                            '& .simplebar-content': {display: 'flex', flexDirection: 'column'}
                        }}>
                            <FormComponent
                                closeModal={closeModal}
                                element={element}
                                onSuccess={onSuccess}
                                pageableData={pageableData}
                            />
                        </SimpleBar>
                    </MainCard>
                </Modal>
            )}
        </>
    )
}